// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"textarea_wrapper__J0mJY","label":"textarea_label__wBp7u","textarea":"textarea_textarea__z_FwX","error":"textarea_error__O5mWq"};